export const LENOVO_PROJECT_ENDPOINT_MAP = {
    695: 'tab_accessories_leads_details',
    697: 'mystery_onsite_audit_details',
    696: 'mystery_cci_audit_details',
    698: 'tab_audit_lead_details'
};

export const TOTAL = 'Total'